import React from 'react';
import { useTheme } from 'styled-components';

const DownloadIcon = ({
  size = 20,
  color,
  actionIcon = false,
  ...props
}) => {
  const theme = useTheme();
  const strokeColor =
    color ??
    (theme?.dark
      ? actionIcon
        ? theme?.actionsIconColor
        : theme?.headingColor
      : '#585558');

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="hover-stroke"
        d="M4.66602 6.66699L7.99935 10.0003L11.3327 6.66699"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="hover-stroke"
        d="M8 10V2"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownloadIcon;
